<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">學生帳號列表</h1>
      </div>
      <div class="header-right">
        <el-button size="mini" type="warning" @click="batchTags" icon="el-icon-tags">批量設置標簽</el-button>
        <el-button
            size="mini"
            type="warning"
            v-if="userInfoRoleRoleId !== teacherRoleId"
            @click="batchSelect"
            icon="el-icon-s-tools"
        >批量轉校HQ</el-button>
        <el-button
            size="mini"
            type="info"
            v-if="userInfoRoleRoleId !== teacherRoleId"
            @click="onDownload"
            icon="el-icon-download"
        >下載</el-button>
      </div>
    </div>

    <div class="layout">
      <!-- 统一风格搜索区 -->
      <div class="search-card">
        <div class="search-row">
          <el-select
              size="small"
              v-model="listQuery.branchSchoolId"
              placeholder="請選擇分校"
              v-if="userInfoRoleRoleId !== teacherRoleId"
              filterable
              ref="branchSchoolSelect"
              :filter-method="filterBranchSchool"
              clearable
          >
            <el-option
                v-for="(item) in filteredBranchSchools"
                :key="item.id"
                :label="`${item.abbreviation || ''}${item.nameZh || ''}`"
                :value="item.id"
                :title="`${item.abbreviation || ''}${item.nameZh || ''}`"
            ></el-option>
          </el-select>
          <el-autocomplete
              popper-class="my-autocomplete"
              v-model="listQuery.tagsLike"
              :fetch-suggestions="querySearch"
              placeholder="請輸入老師標籤"
              @select="handleSelect"
              size="small"
              clearable
          >
            <i
                class="el-icon-edit el-input__icon"
                slot="suffix"
                @click="handleIconClick">
            </i>
            <template slot-scope="{ item }">
              <div class="name">{{ item.value }}</div>
            </template>
          </el-autocomplete>

          <el-input
              size="small"
              v-model="listQuery.userNoLike"
              placeholder="學生帳號"
              prefix-icon="el-icon-user"
              clearable
          ></el-input>

          <el-input
              size="small"
              v-model="listQuery.nameLike"
              placeholder="學生姓名"
              prefix-icon="el-icon-user-solid"
              clearable
          ></el-input>

          <el-select
              size="small"
              v-model="listQuery.gradeId"
              clearable
              placeholder="全部年級"
          >
            <el-option
                v-for="(item, index) in grades"
                :key="index"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>

          <el-input
              size="small"
              v-model="listQuery.parentEmailLike"
              placeholder="搜尋電郵地址"
              prefix-icon="el-icon-message"
              clearable
          ></el-input>
          <el-input
              size="small"
              v-model="listQuery.studentCodeLike"
              placeholder="分校學生編號"
              prefix-icon="el-icon-user-tag"
              clearable
          ></el-input>

          <div class="search-buttons">
            <el-button size="small" type="warning" @click.native="onSearch" icon="el-icon-search">搜尋</el-button>
            <el-button size="small" @click="onReset" icon="el-icon-refresh">重置</el-button>
          </div>
        </div>
      </div>

      <!-- 统一风格 PC表格 + 手机卡片 -->
      <div class="table-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              @sort-change="handleSortChange"
              :data="tableData"
              style="width: 100%;"
              @selection-change="handleSelectionChange"
              border
              stripe
              size="small"
              :empty-text="tableData.length === 0 ? '暫無學生數據' : ''"
          >
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column label="#" type="index" width="40"></el-table-column>
            <el-table-column prop="branchSchoolId" label="分校" align="center" sortable="custom" min-width="80">
              <template slot-scope="{ row }">
                <span v-if="row.branchSchool">{{ row.branchSchool.abbreviation }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="gradeId" label="年級" align="center" sortable="custom" min-width="80">
              <template slot-scope="{ row }">
                <span v-if="row.grade">{{ row.grade.name }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="userNo"
                label="學生帳號"
                align="center"
                sortable="custom"
                min-width="100"
            ></el-table-column>
            <el-table-column
                prop="name"
                label="學生姓名"
                align="center"
                sortable="custom"
                min-width="100"
            ></el-table-column>
            <el-table-column
                prop="status"
                label="帳號狀態"
                align="center"
                sortable="custom"
                width="80"
            >
              <template slot-scope="{ row }">
                <el-tag :type="row.status==1 ? 'success' : 'danger'">
                  {{ row.status | studentCodeStatus }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
                prop="subscriptionStatus"
                label="訂閱狀態"
                align="center"
                sortable="custom"
                min-width="100"
            >
              <template slot-scope="{ row }">
                <el-tag
                    :type="row.subscriptionStatus==1 ? 'success' : row.subscriptionStatus==2 ? 'warning' : 'danger'"
                >
                  {{ row.subscriptionStatus | subscriptionStatus }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
                prop="studentCode"
                label="分校學生編號"
                align="center"
                sortable="custom"
                min-width="100"
            >
              <template slot-scope="{ row }">
                <span>{{ row.studentCode || '-' }}</span>
              </template>
            </el-table-column>

            <el-table-column
                prop="parentEmail"
                label="用戶電郵地址"
                align="center"
                sortable="custom"
                min-width="150"
            >
              <template slot-scope="{row}">
                <span>{{ row.parentEmail || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="studying"
                label="課程"
                align="center"
                sortable="custom"
                width="80"
            >
              <template slot-scope="{row}">
                <el-tag :type="row.studying==0 ? 'primary' : 'info'">
                  {{ row.studying==0 ? '繁' : 'en' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
                label="老師標籤"
                align="center"
                min-width="120"
            >
              <template slot-scope="scope">
                <div class="tags-container">
                  <!-- 先统一处理标签数据，过滤所有空值和无效标签 -->
                  <template v-if="getValidTags(scope.row.tags).length > 0">
                    <el-tag
                        v-for="tag in getValidTags(scope.row.tags)"
                        :key="tag"
                        closable
                        @close="handleTagClose(scope.row, tag)"
                        class="tag-item"
                        size="mini"
                    >
                      {{ tag }}
                    </el-tag>
                  </template>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="createdAt"
                label="創建時間"
                align="center"
                min-width="120"
            >
              <template slot-scope="{ row }">
                <span>{{ row.createdAt | formatDateTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="100">
              <template slot-scope="scope">
                <!-- 把当前行scope.row绑定到dropdown，点击时一起传过去 -->
                <el-dropdown trigger="click" @command="(cmd) => handleMenu(cmd, scope.row)">
      <span class="el-dropdown-link">
        操作 <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="userInfoRoleRoleId != teacherRoleId" command="edit">
                      <i class="el-icon-edit"></i> 編輯
                    </el-dropdown-item>
                    <el-dropdown-item command="detail">
                      <i class="el-icon-view"></i> 詳情
                    </el-dropdown-item>
                    <el-dropdown-item command="performance">
                      <i class="el-icon-data-analysis"></i> 學習表現
                    </el-dropdown-item>
                    <el-dropdown-item command="tag">
                      <i class="el-icon-edit"></i> 標籤設置
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 手机端卡片列表（<768px显示） -->
        <div class="mobile-cards">
          <div class="user-card" v-for="(item) in tableData" :key="item.id">
            <!-- 卡片头部：复选框 + 姓名 + 账号 -->
            <div class="card-header">
              <el-checkbox
                  v-model="item.checked"
                  @change="handleMobileCheck(item)"
                  size="small"
              ></el-checkbox>
              <div class="user-info">
                <div class="user-name">{{ item.name }}</div>
                <div class="user-no">{{ item.userNo }}</div>
              </div>
              <el-button
                  size="mini"
                  type="text"
                  @click="openDialog(item)"
                  icon="el-icon-tags"
              ></el-button>
            </div>

            <!-- 卡片主体：核心信息 -->
            <div class="card-body">
              <div class="info-row">
                <div class="info-item">
                  <span class="info-label">分校：</span>
                  <span class="info-value">{{ item.branchSchool?.abbreviation || '未填寫' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">年級：</span>
                  <span class="info-value">{{ item.grade?.name || '未填寫' }}</span>
                </div>
              </div>
              <div class="info-row">
                <div class="info-item">
                  <span class="info-label">帳號狀態：</span>
                  <el-tag :type="item.status==1 ? 'success' : 'danger'" size="mini">
                    {{ item.status | studentCodeStatus }}
                  </el-tag>
                </div>
                <div class="info-item">
                  <span class="info-label">訂閱狀態：</span>
                  <el-tag
                      :type="item.subscriptionStatus==1 ? 'success' : item.subscriptionStatus==2 ? 'warning' : 'danger'"
                      size="mini"
                  >
                    {{ item.subscriptionStatus | subscriptionStatus }}
                  </el-tag>
                </div>
              </div>
              <div class="info-row">
                <div class="info-item">
                  <span class="info-label">分校編號：</span>
                  <span class="info-value">{{ item.studentCode || '未填寫' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">課程：</span>
                  <el-tag :type="item.studying==0 ? 'primary' : 'info'" size="mini">
                    {{ item.studying==0 ? '繁體' : 'English' }}
                  </el-tag>
                </div>
              </div>
              <div class="info-row">
                <div class="info-item">
                  <span class="info-label">電郵：</span>
                  <span class="info-value">{{ item.parentEmail || '未填寫' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">老師標籤：</span>
                  <div class="tag-group">

                    <template v-if="getValidTags(item.tags).length > 0">
                      <el-tag
                          v-for="tag in getValidTags(item.tags)"
                          :key="tag"
                          closable
                          @close="handleTagClose(item, tag)"
                          class="tag-item"
                          size="mini"
                      >
                        {{ tag }}
                      </el-tag>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <!-- 卡片操作栏 -->
            <div class="card-actions">
              <el-button
                  size="mini"
                  type="text"
                  v-if="userInfoRoleRoleId != teacherRoleId"
                  @click="onEditorButton(item)"
                  icon="el-icon-edit"
              >編輯</el-button>
              <el-button
                  size="mini"
                  type="text"
                  @click="onDetailButton(item.parentId)"
                  icon="el-icon-view"
              >詳情</el-button>
              <el-button
                  size="mini"
                  type="text"
                  @click="goToLearningPerformance(item.id,item.userNo,item.studying,item.grade?.id ?? 1)"
                  icon="el-icon-data-analysis"
              >學習表現</el-button>
            </div>
          </div>

          <!-- 空数据提示 -->
          <div class="empty-tip" v-if="tableData.length === 0">
            暫無學生數據
          </div>
        </div>
      </div>

      <!-- 分页组件 -->
      <div class="pagination-wrap">
        <Pagination
            v-show="total > 0"
            :total="total"
            :page.sync="listQuery._page"
            :limit.sync="listQuery._limit"
            @pagination="getUsers"
        />
      </div>

      <!-- 自定义弹窗（标签输入框 + 表单校验） -->
      <el-dialog
          title="輸入老師標籤"
          :visible.sync="dialogVisible"
          width="90%"
          max-width="1200px"
          :before-close="handleDialogClose"
      >
        <el-form :model="tagForm" ref="tagFormRef" size="small">
          <el-form-item label="標籤" prop="tag" label-width="60px">
            <el-autocomplete
                popper-class="my-autocomplete"
                v-model="tagForm.tags"
                :fetch-suggestions="querySearch"
                placeholder="請輸入老師標籤"
                @select="handleSelect"
                style="width: 100%"
                clearable
            >
              <i
                  class="el-icon-edit el-input__icon"
                  slot="suffix"
                  @click="handleIconClick">
              </i>
              <template slot-scope="{ item }">
                <div class="name">{{ item.value }}</div>
              </template>
            </el-autocomplete>
            <div class="form-hint">提示：多個標籤之間用英文逗號（,）分隔</div>

            <!-- 老师搜索区域 -->
            <div class="teacher-search-card">
              <div class="search-row">
                <div class="search-item">
                  <div class="search-text">老師帳號</div>
                  <el-input
                      v-model="formLabelAlign.userNoLike"
                      placeholder=""
                      @change="getTeachers"
                      clearable
                      @input="handleInputDebounce"
                  ></el-input>
                </div>
                <div class="search-item">
                  <div class="search-text">老師姓名</div>
                  <el-input
                      v-model="formLabelAlign.nameLike"
                      placeholder=""
                      clearable
                  ></el-input>
                </div>
                <div class="search-buttons">
                  <el-button type="info" @click="getTeachers" icon="el-icon-search">搜尋</el-button>
                  <el-button type="warning" @click="handleSubmit" icon="el-icon-check">確定</el-button>
                </div>
              </div>

              <!-- 老师列表表格 -->
              <el-table
                  :data="teacherTableData"
                  size="small"
                  border
                  :empty-text="teacherTableData.length === 0 ? '暫無老師數據' : ''"
              >
                <el-table-column label="#" type="index" width="50"> </el-table-column>
                <el-table-column
                    prop="userNo"
                    label="職員帳號"
                    align="center"
                    min-width="100"
                ></el-table-column>
                <el-table-column
                    prop="name"
                    label="姓名"
                    align="center"
                    min-width="100"
                ></el-table-column>
                <el-table-column
                    prop="branchSchoolId"
                    label="分校"
                    align="center"
                    min-width="100"
                >
                  <template slot-scope="{ row }">
                    <span v-if="row.branchSchool">{{ row.branchSchool.abbreviation }}</span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                  <template slot-scope="{ row }">
                    <el-button type="text" size="small" @click="selectTeacherName(row)" icon="el-icon-check">選擇</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取消</el-button>
          <el-button size="small" type="warning" @click="handleSubmit">確定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { changeSchools, editTags, getUsers, getTags } from "@/api/users";
import Pagination from "@/components/Pagination";
import { downloadFile } from "@/utils/is-rules";
import { getStudentReport } from "@/api/report";
import { getGrades } from '@/api/grade'

export default {
  components: { Pagination },
  filters: {
    studentCodeStatus(v) {
      return v === 0 ? "封鎖" : "生效";
    },
    subscriptionStatus(v) {
      return v === 0 ? "無訂閱" : v === 1 ? "訂閱中" : v === 2 ? "過期" : "等待開始";
    },
    formatDateTime(time) {
      if (!time) return "";
      const d = new Date(time);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
    }
  },
  data() {
    return {
      filteredBranchSchools: [],
      restaurants: [],
      state: '',
      selectedRows: [],
      total: 0,
      userId: null,
      listQuery: {
        tagsLike: null,
        userNoLike: null,
        nameLike: null,
        parentEmailLike: null,
        studentCodeLike: null,
        gender: null,
        gradeId: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      centerDialogVisible: false,
      dialogSlotVisible: false,
      tableData: [],
      avatars: [],
      grades: [],
      form: {
        ids: null,
      },
      dialogVisible: false,
      tagForm: {
        tags: '',
        ids: null,
        del: 0
      },
      rules: {
        tags: [
          { required: true, message: '请输入标签', trigger: 'blur' }
        ]
      },
      tags: null,
      allTag: "",
      tagsUserId: null,
      formLabelAlign: {
        type: 0,
        userNoLike: null,
        nameLike: null,
        emailLike: null,
        roleId: null,
        phoneLike: null,
        branchSchoolId: null,
        gender: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      teacherTableData: [],
      teacherTableDataTotal: 0,
      // 补充角色ID变量
      userInfoRoleRoleId: this.$store.getters.userInfo?.roleId || '',
      adminUserInfoRoleId: this.$store.getters.userInfo?.roleId || '',
      teacherRoleId: 2,
      // 移动端复选框状态
      inputTimer: null
    };
  },
  created() {
    this.getUsers();
    this.getGrades();
    this.getTags();
    this.filteredBranchSchools = this.$store.getters.branchSchools || [];
  },
  methods: {
    handleMenu(command, row) {
      switch (command) {
        case 'edit':
          this.onEditorButton(row)
          break
        case 'detail':
          this.onDetailButton(row.parentId)
          break
        case 'performance':
          this.goToLearningPerformance(row.id, row.userNo, row.studying, row.grade?.id ?? 1)
          break
        case 'tag':
          this.openDialog(row)
          break
      }
    },
    // 自定义筛选方法：根据输入关键词匹配校区缩写
    filterBranchSchool(val) {
      const branchSchools = this.$store.getters.branchSchools || [];

      if (!val) {
        this.filteredBranchSchools = branchSchools;
      } else {
        const searchText = val.toLowerCase().trim();
        this.filteredBranchSchools = branchSchools.filter(item => {
          const abbreviation = (item.abbreviation || '').toLowerCase();
          const nameZh = (item.nameZh || '').toLowerCase();
          const nameEn = (item.nameEn || '').toLowerCase();
          return abbreviation.includes(searchText) || nameZh.includes(searchText) || nameEn.includes(searchText);
        });
      }
    },
    // 处理标签数据，过滤空值、空格、无效标签
    getValidTags(tagsStr) {
      // 1. 处理 null/undefined/空字符串
      if (!tagsStr || typeof tagsStr !== 'string') {
        return [];
      }

      // 2. 分割标签 + 去除首尾空格 + 过滤空标签
      return tagsStr.split(',')
          .map(tag => tag.trim()) // 去除每个标签的首尾空格
          .filter(tag => tag);    // 过滤空字符串（包括纯空格的标签）
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        // 1. 容错处理：避免restaurant/value为空时报错
        if (!restaurant || !restaurant.value) return false;

        // 2. 核心修改：indexOf === 0（开头匹配）→ includes（任意位置模糊匹配）
        return restaurant.value.toLowerCase().includes(queryString.toLowerCase().trim());
      };
    },
    handleSelect(item) {
      console.log(item);
    },
    handleIconClick(ev) {
      console.log(ev);
    },
    // 打开弹窗
    openDialog(row) {
      this.getTeachers();
      this.tags = row.tags;
      this.tagsUserId = row.id;
      this.tagForm.ids = row.id;
      this.tagForm.tags = '';
      this.$nextTick(() => {
        this.$refs.tagFormRef?.clearValidate();
      });
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleDialogClose() {
      this.tagForm.tags = '';
      this.tagForm.ids = null;
      this.$refs.tagFormRef?.clearValidate();
      this.dialogVisible = false;
      this.getUsers();
    },
    // 提交标签
    handleSubmit() {
      this.$refs.tagFormRef.validate(valid => {
        if (valid) {
          editTags(this.tagForm).then(() => {
            this.$message.success("標籤設置成功！");
            this.getUsers();
            this.getGrades();
          }).catch(err => {
            this.$message.error("標籤設置失敗，請稍後重試");
            console.error('标签设置失败：', err);
          });
          this.dialogVisible = false;
        }
      });
    },
    // 批量设置标签
    batchTags() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('請選擇數據！');
        return;
      }
      this.$nextTick(() => {
        this.$refs.tagFormRef?.clearValidate();
      });
      this.dialogVisible = true;
      this.tagForm.tags = '';
      this.tagForm.del = 0;
      this.tagForm.ids = this.selectedRows.map(row => row.id).join(',');
      this.getTeachers();
      this.getTags();
    },
    // 删除已选标签
    handleTagClose(row, tagToRemove) {
      let tagsArray = row.tags.split(',').map(tag => tag.trim());
      let newTagsArray = tagsArray.filter(tag => tag !== tagToRemove);
      this.tags = newTagsArray.join(',');

      this.tagForm.tags = this.tags;
      this.tagForm.ids = row.id;
      this.tagForm.del = 1;

      editTags(this.tagForm).then(() => {
        this.$message({
          type: 'info',
          message: `已删除标签：${tagToRemove}`
        });
        this.getUsers();
      }).catch(err => {
        this.$message.error("标签删除失败，請稍後重試");
        console.error('标签删除失败：', err);
      });
    },
    // 处理复选框选择变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      // 同步移动端复选框状态
      this.tableData.forEach(item => {
        item.checked = selection.some(row => row.id === item.id);
      });
    },
    // 移动端复选框处理
    handleMobileCheck(item) {
      if (item.checked) {
        // 添加到选中列表
        if (!this.selectedRows.some(row => row.id === item.id)) {
          this.selectedRows.push(item);
        }
      } else {
        // 从选中列表移除
        this.selectedRows = this.selectedRows.filter(row => row.id !== item.id);
      }
    },
    // 批量转校
    batchSelect() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('請選擇數據！');
        return;
      }
      const isConfirm = window.confirm('您確定批量轉校這些學生嗎！');
      if (isConfirm) {
        this.form.ids = this.selectedRows.map(row => row.id).join(',');
        changeSchools(this.form).then(() => {
          this.$message.success("轉校成功");
          this.getUsers();
          this.getGrades();
        }).catch(err => {
          this.$message.error("轉校失敗，請稍後重試");
          console.error('转校失败：', err);
        });
      }
    },
    // 获取年级列表
    getGrades() {
      getGrades().then((res) => {
        this.grades = res.data || [];
      }).catch(err => {
        this.$message.error("獲取年級列表失敗，請稍後重試");
        console.error('获取年级失败：', err);
      });
    },
    // 下载报表
    onDownload() {
      this.getStudentReport();
    },
    // 获取学生报表
    getStudentReport() {
      let form = {
        tags: this.listQuery.tagsLike || null,
        nameLike: this.listQuery.nameLike || null,
        userNoLike: this.listQuery.userNoLike || null,
        parentEmailLike: this.listQuery.parentEmailLike || null,
        gender: this.listQuery.gender,
        branchSchoolId: this.listQuery.branchSchoolId || null,
        gradeId: this.listQuery.gradeId || null,
        studentCodeLike: this.listQuery.studentCodeLike || null
      };
      getStudentReport(form).then((res) => {
        downloadFile(res.data, 'studentReport.xlsx');
      }).catch(err => {
        this.$message.error("下載報表失敗，請稍後重試");
        console.error('下载报表失败：', err);
      });
    },
    // 排序处理
    handleSortChange(column) {
      this.listQuery.orderBy = column.order ? `${column.prop} ${column.order === "descending" ? "desc" : "asc"}` : null;
      this.listQuery._page = 1;
      this.getUsers();
    },
    // 搜索
    onSearch() {
      this.listQuery._page = 1;
      this.getUsers();
    },
    // 重置
    onReset() {
      Object.keys(this.listQuery).forEach((key) => {
        this.listQuery[key] = null;
        if (key === "_page") {
          this.listQuery[key] = 1;
        } else if (key === "_limit") {
          this.listQuery[key] = 10;
        }
      });
      // 重置校区筛选
      this.filteredBranchSchools = this.$store.getters.branchSchools || [];
      this.getUsers();
    },
    // 路由跳转
    resolveRouter(path) {
      this.$router.push(path);
    },
    // 学习表现
    goToLearningPerformance(id, userNo, studying, gradeId) {
      let path = `/student/${id}/learning-performance/${userNo}?studying=${studying}&gradeId=${gradeId}`;
      this.resolveRouter(path);
    },
    // 编辑
    onEditorButton(row) {
      let path = `/student/${row.parentId}/edit?studentId=${row.id}&type=student`;
      this.resolveRouter(path);
    },
    // 详情
    onDetailButton(id) {
      let path = `/student/${id}`;
      this.resolveRouter(path);
    },
    // 获取用户列表
    getUsers() {
      let listQuery = {
        type: 2,
        tags: this.listQuery.tagsLike,
        userNoLike: this.listQuery.userNoLike,
        nameLike: this.listQuery.nameLike,
        parentEmailLike: this.listQuery.parentEmailLike,
        studentCodeLike: this.listQuery.studentCodeLike,
        branchSchoolId: this.listQuery.branchSchoolId,
        gender: this.listQuery.gender,
        gradeId: this.listQuery.gradeId,
        orderBy: this.listQuery.orderBy,
        _page: this.listQuery._page - 1,
        _limit: this.listQuery._limit,
      };
      // 清空空值参数
      Object.keys(listQuery).forEach(key => {
        if (listQuery[key] === null || listQuery[key] === undefined) {
          delete listQuery[key];
        }
      });
      getUsers(listQuery).then((v) => {
        this.tableData = v.data || [];
        this.total = Number(v.headers["x-total-count"]) || 0;
        // 初始化移动端复选框状态
        this.tableData.forEach(item => {
          item.checked = this.selectedRows.some(row => row.id === item.id);
        });
      }).catch(err => {
        this.$message.error("獲取學生列表失敗，請稍後重試");
        console.error('获取学生列表失败：', err);
        this.tableData = [];
        this.total = 0;
      });
    },
    // 获取标签列表
    getTags() {
      getTags().then((v) => {
        this.allTag = v.data || '';
        const result = this.allTag.split(',')
            .map(item => item.trim())
            .filter(item => item)
            .filter((item, index, self) => self.indexOf(item) === index)
            .map(item => ({ value: item }));

        this.restaurants = result;
      }).catch(err => {
        console.error('获取标签失败：', err);
      });
    },
    // 防抖处理
    handleInputDebounce() {
      if (this.inputTimer) clearTimeout(this.inputTimer);
      this.inputTimer = setTimeout(() => {
        this.getTeachers();
      }, 500);
    },
    // 获取老师列表
    getTeachers() {
      let listQuery = {
        type: 0,
        userNoLike: this.formLabelAlign.userNoLike,
        nameLike: this.formLabelAlign.nameLike,
        emailLike: this.formLabelAlign.emailLike,
        phoneLike: this.formLabelAlign.phoneLike,
        roleId: 2,
        gender: this.formLabelAlign.gender,
        branchSchoolId: this.formLabelAlign.branchSchoolId,
        orderBy: this.formLabelAlign.orderBy,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };
      // 清空空值参数
      Object.keys(listQuery).forEach(key => {
        if (listQuery[key] === null || listQuery[key] === undefined) {
          delete listQuery[key];
        }
      });
      getUsers(listQuery).then((v) => {
        this.teacherTableData = v.data || [];
        this.teacherTableDataTotal = Number(v.headers["x-total-count"]) || 0;
      }).catch(err => {
        this.$message.error("獲取老師列表失敗，請稍後重試");
        console.error('获取老师列表失败：', err);
        this.teacherTableData = [];
      });
    },
    // 选择老师姓名
    selectTeacherName(row) {
      const userNo = row.userNo?.trim() || '';
      if (!userNo) return;

      if (this.tagForm.tags && this.tagForm.tags.trim() !== '') {
        this.tagForm.tags = `${this.tagForm.tags},${userNo}`;
      } else {
        this.tagForm.tags = userNo;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 统一风格页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 20px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0;
    }
  }

  .header-right {
    display: flex;
    gap: 8px;
  }
}

/* 布局容器 */
.layout {
  background: #fff;
  border-radius: 8px;
  //padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 统一风格搜索卡片 */
.search-card {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;

    .el-autocomplete, .el-input, .el-select {
      flex: 1;
      width: 100%;
      min-width: unset;
    }

    .search-buttons {
      display: flex;
      gap: 8px;
      flex-shrink: 0;
    }
  }
}

/* 表格/卡片容器 */
.table-container {
  width: 100%;
  //margin-bottom: 20px;

  /* PC端表格样式 */
  .pc-table {
    ::v-deep .el-table {
      --el-table-header-text-color: #4e5969;
      --el-table-row-hover-bg-color: #f8f9fa;
    }

    ::v-deep .el-table th {
      background: #f8f9fa;
      font-weight: 600;
    }

    .tags-container {
      margin-top: 4px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 4px;
    }

    .tag-item {
      transition: all 0.3s ease;
    }

    .tag-item:hover {
      transform: scale(1.05);
    }
  }

  /* 手机端卡片列表样式 */
  .mobile-cards {
    display: none;
    gap: 12px;
    flex-direction: column;

    .user-card {
      background: #fff;
      border: 1px solid #e9ecef;
      border-radius: 8px;
      padding: 16px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

      /* 卡片头部 */
      .card-header {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .el-checkbox {
          margin-right: 12px;
        }

        .user-info {
          flex: 1;

          .user-name {
            font-size: 16px;
            font-weight: 600;
            color: #1f2937;
            margin-bottom: 4px;
          }

          .user-no {
            font-size: 12px;
            color: #6c757d;
          }
        }
      }

      /* 卡片主体 */
      .card-body {
        margin-bottom: 12px;

        .info-row {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-bottom: 8px;
          align-items: center;

          &.full-width {
            width: 100%;
          }

          .info-item {
            display: flex;
            align-items: center;
            gap: 4px;

            .info-label {
              color: #6c757d;
              font-size: 12px;
              white-space: nowrap;
            }

            .info-value {
              color: #1f2937;
              font-size: 12px;
            }
          }

          .tag-group {
            display: flex;
            flex-wrap: wrap;
            gap: 4px;
            flex: 1;
          }

          .mobile-tag {
            font-size: 11px;
            height: 20px;
            line-height: 20px;
          }
        }
      }

      /* 卡片操作栏 */
      .card-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        padding-top: 12px;
        border-top: 1px solid #f1f3f5;

        .el-button {
          padding: 4px 8px;
          font-size: 12px;
        }
      }
    }

    .empty-tip {
      text-align: center;
      padding: 32px;
      color: #999;
      font-size: 14px;
    }
  }
}

/* 分页样式 */
.pagination-wrap {
  text-align: center;
  ::v-deep .el-pagination {
    --el-pagination-button-bg-color: #fff;
    --el-pagination-button-hover-bg-color: #f8f9fa;
    --el-pagination-button-active-bg-color: #409eff;
  }
}

/* 弹窗样式 */
::v-deep .el-dialog {
  .teacher-search-card {
    margin-top: 16px;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 6px;

    .search-row {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      margin-bottom: 12px;
      align-items: flex-end;

      .search-item {
        flex: 1;
        min-width: 180px;

        .search-text {
          margin-bottom: 4px;
          font-size: 12px;
          color: #6c757d;
        }
      }

      .search-buttons {
        display: flex;
        gap: 8px;
        flex-shrink: 0;
      }
    }
  }

  .form-hint {
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
  }
}

/* 自定义样式 */
.studentCode {
  color: #027915;
}

.isStudentCode {
  color: #9C0000;
}

.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .page {
    padding: 8px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding-bottom: 8px;
  }

  .layout {
    padding: 12px;
  }

  /* 搜索栏垂直排列 */
  .search-card .search-row {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .search-card .search-row .el-autocomplete,
  .search-card .search-row .el-input,
  .search-card .search-row .el-select {
    width: 100% !important;
    min-width: unset !important;
  }

  /* 隐藏PC表格，显示手机卡片 */
  .table-container .pc-table {
    display: none;
  }

  .table-container .mobile-cards {
    display: flex;
  }

  /* 弹窗适配 */
  ::v-deep .el-dialog {
    width: 95% !important;
    margin: 10px auto !important;

    .teacher-search-card .search-row {
      flex-direction: column;
      align-items: stretch;
    }
  }
}
</style>